import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const MadisonMobile = ({ data }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");
  const isHeaderRow = (row) => row[0]?.toLowerCase() === "rnk" && row[2]?.toLowerCase() === "last name";

  const filteredRows = data.filter(row => !isSpacer(row) && !isHeaderRow(row));

  const renderRiderPair = (row1, row2, index) => {
    const rank = row1[0] || "";
    const lastName1 = row1[2] || "";
    const firstName1 = row1[3] || "";
    const country1 = row1[4] || "";

    const lastName2 = row2[2] || "";
    const firstName2 = row2[3] || "";
    const country2 = row2[4] || "";

    const points = row1[5] || "";

    return (
      <div key={index} className="ssm-battle madison-block">
        <div className="madison-rank-column">
          <div className="madison-rank">{rank}</div>
        </div>

        <div className="madison-pair">
          <div className="madison-rider-info">
            <div className="madison-name">
              <div className="ssm-last-name">{lastName1}</div>
              <div className="ssm-first-name">{firstName1}</div>
            </div>
            <img src={getFlagUrl(country1)} alt={country1} className="flag-icon" />
          </div>

          <div className="madison-rider-info">
            <div className="madison-name">
              <div className="ssm-last-name">{lastName2}</div>
              <div className="ssm-first-name">{firstName2}</div>
            </div>
            <img src={getFlagUrl(country2)} alt={country2} className="flag-icon" />
          </div>
        </div>

        <div className="madison-points-column">
          <div className="madison-total-points">{points}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-madison-series">
      {(() => {
        const rendered = [];
        for (let i = 0; i < filteredRows.length; i += 2) {
          const row1 = filteredRows[i];
          const row2 = filteredRows[i + 1];

          if (!row1 || !row2) continue;

          rendered.push(renderRiderPair(row1, row2, i));
        }
        return rendered;
      })()}
    </div>
  );
};

export default MadisonMobile;
